module.exports = __webpack_public_path__ + "8243e924648b443a9462ab22a6f79961.svg";